module.exports = __webpack_public_path__ + "img/logo_skype.5ae57ad0.svg";